import React, { useState } from 'react';
import AUX from '../../../hoc/Aux_';
import { MDBDataTable } from 'mdbreact';
import { Button } from 'reactstrap';
import Dropdown from '../filters/Dropdown';

const UsList = [
  {
    id: 1,
    web: 'Figma',
    typ: 'Graphic Design',
    pr: 'Campaign Management',
    us: 'Luna Andersan',
    ms: '1211',
    key: '12221',
    sr: '655',
    in: '10.9 %',
    tt: '30.5 %',
  },
  {
    id: 2,
    web: 'Google Chrome',
    typ: 'Browser',
    pr: 'Web Design',
    us: 'Kate winston',
    ms: '2322',
    key: '23112',
    sr: '145',
    in: '20.9 %',
    tt: '25h 8m',
  },
  {
    id: 3,
    web: 'Google Chrome',
    typ: 'Browser',
    pr: 'Web Design',
    us: 'Liana Paper',
    ms: '1123',
    key: '12321',
    sr: '322',
    in: '40.0 %',
    tt: '22h 12m',
  },
  {
    id: 4,
    web: 'Slack',
    typ: 'Chat',
    pr: 'User',
    us: 'Anne Miller',
    ms: '1233',
    key: '32211',
    sr: '544',
    in: '29.0 %',
    tt: '26h 0m',
  },
  {
    id: 5,
    web: 'VS Code',
    typ: 'Code',
    pr: 'Coding',
    us: 'Mohit K',
    ms: '2311',
    key: '34212',
    sr: '332',
    in: '35.3 %',
    tt: '29h 3m',
  },
];

// Reusable Dropdown Component

const AppsAndWeb = () => {
  const data = {
    columns: [
      { label: 'Apps / Website', field: 'web' },
      { label: 'Type', field: 'typ' },
      { label: 'Project', field: 'pr' },
      { label: 'User', field: 'us' },
      { label: 'Mouse', field: 'ms' },
      { label: 'Keyboard', field: 'key' },
      { label: 'Scroll', field: 'sr' },
      { label: 'Inactive', field: 'in' },
      { label: 'Total', field: 'tt' },
    ],
    rows: UsList.map((Item) => ({
      web: Item?.web,
      typ: Item?.typ,
      pr: Item?.pr,
      us: Item?.us,
      ms: Item?.ms,
      key: Item?.key,
      sr: Item?.sr,
      in: Item?.in,
      tt: Item?.tt,
    })),
  };

  return (
    <AUX>
      <div className="page-content-wrapper">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="row">
                <div className="col-12">
                  <div className="card m-b-20">
                    <div className="d-flex justify-content-between align-items-center card-body">
                      <div className="col-md-8 d-flex justify-content-start align-items-center mt-2">
                        <p className="text-muted">Filter by :</p>
                        <Dropdown
                          label="Members"
                          items={[
                            'Action',
                            'Another action',
                            'Something else here',
                          ]}
                          icon={'mdi mdi-account-multiple-outline'}
                        />
                        <Dropdown
                          label="Projects"
                          items={['Project 1', 'Project 2', 'Project 3']}
                          icon={'mdi mdi-account-multiple-outline'}
                        />
                        <Dropdown
                          label="Teams"
                          items={['Team A', 'Team B', 'Team C']}
                          icon={'mdi mdi-account-multiple-outline'}
                        />
                        <p className="text-muted ml-4 mt-1 d-flex justify-content-start align-items-center">
                          <i className="mdi mdi-calendar-text font-20 mr-2 text-muted u_icon"></i>{' '}
                          2011-11-28 -&gt; 2022-12-04
                        </p>
                      </div>
                      <Button
                        className="btn bg-purple pl-4 pr-4 mb-2"
                        size="sm"
                      >
                        Apply
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card m-b-20">
                <div className="card-body">
                  <div className="d-flex justify-content-end mb-2">
                    <select className="form-control btn-sm col-1 mr-1">
                      <option value="true">Columns</option>
                      <option value="false">In-Active</option>
                    </select>
                    <select className="form-control btn-sm col-1">
                      <option value="true">Export</option>
                      <option value="false">In-Active</option>
                    </select>
                  </div>
                  <MDBDataTable
                    bordered
                    hover
                    data={data}
                    paging={false}
                    searching={false}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AUX>
  );
};

export default AppsAndWeb;
